module.exports = __webpack_public_path__ + "img/linknau-logo.9f677334.svg";